module.exports = __webpack_public_path__ + "static/media/img.985e8557.png";